import React from 'react';
import { Alert, Box, Button, CircularProgress, Divider, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useTranslation } from 'react-i18next';
import useGoogleSignInButton from '../../hooks/useGoogleSignInButton';
import { BRAND, brandAlpha } from '../../theme/brandTokens';

const GoogleSignInSection = ({
  onCredential,
  loading,
  buttonText = 'signin_with',
}) => {
  const { t } = useTranslation();
  const {
    buttonRef,
    thirdPartyAllowed,
    openPreferences,
    useOAuthRedirect,
    redirectToGoogleOAuth,
  } = useGoogleSignInButton(onCredential, { buttonText });

  return (
    <Box sx={{ width: '100%', mt: 2, mb: 2 }}>
      <Divider sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {t('login.or')}
        </Typography>
      </Divider>

      {!thirdPartyAllowed ? (
        <Alert
          severity="info"
          sx={{
            mb: 2,
            borderRadius: 2,
            alignItems: 'flex-start',
          }}
          action={(
            <Button color="inherit" size="small" onClick={openPreferences} sx={{ textTransform: 'none', fontWeight: 700 }}>
              {t('legal.consent.openCookieSettings')}
            </Button>
          )}
        >
          {t('legal.consent.googleDisabled')}
        </Alert>
      ) : (
        <Box
          sx={{
            width: '100%',
            minHeight: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            mb: 2,
          }}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : useOAuthRedirect ? (
            <Button
              fullWidth
              variant="outlined"
              size="large"
              startIcon={<GoogleIcon />}
              onClick={redirectToGoogleOAuth}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderColor: '#dadce0',
                color: '#3c4043',
                py: 1.25,
                '&:hover': {
                  borderColor: BRAND.accent,
                  bgcolor: brandAlpha('accent', 0.06),
                },
              }}
            >
              {buttonText === 'signup_with' ? t('googleAuth.continueWithGoogleSignUp') : t('googleAuth.continueWithGoogle')}
            </Button>
          ) : (
            <Box
              ref={buttonRef}
              sx={{
                width: '100%',
                overflow: 'hidden',
                '& > div': {
                  width: '100% !important',
                  overflow: 'hidden !important',
                },
                '& iframe': {
                  overflow: 'hidden !important',
                },
              }}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default GoogleSignInSection;
